/*! @azure/msal-react v2.0.19 2024-06-10 */
'use strict';
import * as React from 'react';
import { stubbedPublicClientApplication, InteractionStatus, Logger } from '@azure/msal-browser';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */
const defaultMsalContext = {
    instance: stubbedPublicClientApplication,
    inProgress: InteractionStatus.None,
    accounts: [],
    logger: new Logger({}),
};
const MsalContext = React.createContext(defaultMsalContext);
const MsalConsumer = MsalContext.Consumer;

export { MsalConsumer, MsalContext };
//# sourceMappingURL=MsalContext.js.map
